//#region ENUM EDeviceOrientationEnum
export enum EDeviceOrientationEnum {
  LandscapePrimary = 'landscape-primary',
  LandscapeSecondary = 'landscape-secondary',
  PortraitPrimary = 'portrait-primary',
  PortraitSecondary = 'portrait-secondary',
  Unknown = 'unknown',
}
//#endregion

//#region TYPE DeviceOrientationEnumType
export type DeviceOrientationEnumType = `${EDeviceOrientationEnum}`;
//#endregion
